import { API } from "./api";

export const getAllVehiclePricings = () => API.get(`/pricing`);

export const createVehiclePricing = (pricing) => API.post(`/pricing`, pricing);

export const deleteVehiclePricing = (pricingId) =>
  API.delete(`/pricing/${pricingId}`);

export const updateVehiclePricing = (id, pricing) =>
  API.put(`/pricing/${id}`, pricing);
